import DashboardPage from '@/modules/dashboard/dashboard-page';
import DashboardDataProvider from '@/utils/stats/dashboard-context';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DashboardDataProvider>
      <DashboardPage />
    </DashboardDataProvider>
  );
}
